import './Article.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react";
import Upload from 'Components/Upload/Upload';
import Clips from 'Components/Clips/Clips';
import Metadata from 'Components/Metadata/Metadata';

const Article = observer(
  class Article extends Component {
    state={
			artid:0,
      article: false,
			actview: 'Upload'
		}

		constructor(props) {
			super(props);
			if (props.data) {
				this.state.article = props.data;
			}
			else if(props.id) {
				this.state.artid = props.id;
			}
		}

		componentDidMount() {
			this.loadArticle();
		}
	
		async loadArticle(view) {
			if(!view)
				view = this.state.actview;
			this.setState({article:false});
			this.props.flow.cccmylog('Article -> loadArticle ' + this.state.artid);
			try {
				var art = await this.props.flow.getDistprojectById(this.state.artid);
				let ownerid = art.getMetadata().get('owner');
				var us = await this.props.flow.getUserById(ownerid);
				this.setState({ownermail:us.email,article:art,actview:view});
			}
			catch(err) {
				this.props.flow.cccmylog('Article -> loadArticle failed:' + err.message);
			}
		}
	
		setView(view) {
			if(view === 'Clips')
				this.loadArticle('Clips');
			else
				this.setState({actview:view});
		}
	
		render() {
			if(this.state.article === false) 
				return  (
					<div>
						<div className="articleheadline">	Artikel: </div>
						<div>'wait...'</div>
					</div>	
				);
			else {
				let result = <Metadata article={this.state.article} />
				if (this.state.actview === 'Clips') 
					result = <Clips reloadcb={()=>{ this.loadArticle() }} article={this.state.article} />
				if (this.state.actview === 'Upload') 
					result = <Upload setHeaderMess={this.props.setHeaderMess} userid={this.props.userid} ownermail={this.state.ownermail}  cbartsearchclicked={this.props.cbartsearchclicked}  reloadcb={()=>{ this.loadArticle() }} article={this.state.article} />
				return  (
					<div>
						<div className="articleheadline">	Artikel: <b> {this.state.article.getMetadata().get('title')}</b></div>
						<div id="articlemenue">
							<div id="loadMetadata" onClick={()=>{ this.setView('Metadata') }} className={"actviewswitch " + (this.state.actview === 'Metadata' ? 'active' : 'passive')} >Metadata</div>
							<div id="loadClips" onClick={()=>{ this.setView('Clips') }} className={"actviewswitch " + (this.state.actview === 'Clips' ? 'active' : 'passive')} >Clips</div>
							<div id="loadUpload" onClick={()=>{ this.setView('Upload') }} className={"actviewswitch " + (this.state.actview === 'Upload' ? 'active' : 'passive')} >Upload</div>
						</div>
						{result}
					</div>
				);
			}
		}
		
  }
)


export default Flow.injectFlow(Article);